[
  {
    "id": "mostUsed",
    "icons": [
      { "id": "Nr.1_3_001-1_v1" },
      { "id": "circle" },
      { "id": "5021_Baustelle" },
      { "id": "5022_Einfahrt_Verboten" },
      { "id": "201_Buslichtzeichen" },
      { "id": "202_Ampeln" },
      { "id": "204_Andreaskreuz" },
      { "id": "cross_v1" },
      { "id": "cross_black_v1" },
      {
        "id": "rheinbahn_rhb_absperrung_v1"
      },
      {
        "id": "rheinbahn_rhb_diamant_ersatzbus_v1"
      },
      {
        "id": "rheinbahn_rhb_diamant_sev_v1"
      },
      {
        "id": "rheinbahn_rhb_fussweg_01_v1"
      },
      {
        "id": "rheinbahn_rhb_fussweg_02_v1"
      },
      {
        "id": "rheinbahn_rhb_hst_v1"
      }
    ]
  },
  {
    "id": "Rheinbahn",
    "icons": [
      {
        "id": "rheinbahn_rhb_absperrung_v1"
      },
      {
        "id": "rheinbahn_rhb_diamant_ersatzbus_v1"
      },
      {
        "id": "rheinbahn_rhb_diamant_sev_v1"
      },
      {
        "id": "rheinbahn_rhb_fussweg_01_v1"
      },
      {
        "id": "rheinbahn_rhb_fussweg_02_v1"
      },
      {
        "id": "rheinbahn_rhb_hst_v1"
      },
      {
        "id": "rheinbahn_rhb_hst_ersatz_v1"
      },
      {
        "id": "rheinbahn_rhb_hst_fahrtrichtung_01_v1"
      },
      {
        "id": "rheinbahn_rhb_hst_gesperrt_v1"
      },
      {
        "id": "rheinbahn_rhb_hst_steig_01_v1"
      },
      {
        "id": "rheinbahn_rhb_hst_steig_02_v1"
      },
      {
        "id": "rheinbahn_rhb_hst_steig_03_v1"
      },
      {
        "id": "rheinbahn_rhb_hst_steig_04_v1"
      },
      {
        "id": "rheinbahn_rhb_hst_steig_gesperrt_01_v1"
      },
      {
        "id": "rheinbahn_rhb_hst_steig_gesperrt_02_v1"
      },
      {
        "id": "rheinbahn_rhb_hst_steig_gesperrt_03_v1"
      },
      {
        "id": "rheinbahn_rhb_hst_steig_gesperrt_04_v1"
      },
      {
        "id": "rheinbahn_rhb_richtungspfeil_v1"
      },
      {
        "id": "rheinbahn_rhb_richtungspfeil_fussweg_v1"
      },
      {
        "id": "rheinbahn_rhb_richtungspfeil_sev_v1"
      },
      {
        "id": "rheinbahn_rhb_richtungspfeil_stadtbahn_v1"
      },
      {
        "id": "rheinbahn_rhb_richtungspfeil_ubahn_v1"
      }
    ]
  },
  {
    "id": "01_Gleise",
    "icons": []
  },
  {
    "id": "Externe kommerzielle Einrichtungen",
    "icons": [
      {
        "id": "Nr.1_8_001-1_v1"
      },
      {
        "id": "Nr.2_8_010-1_v1"
      },
      {
        "id": "Nr.3_8_011-1_v1"
      },
      {
        "id": "Nr.4_8_012-1_v1"
      },
      {
        "id": "Nr.5_8_020-1_v1"
      }
    ]
  },
  {
    "id": "Information zur Reisekette 1",
    "icons": [
      {
        "id": "Nr.10_1_020-1_v1"
      },
      {
        "id": "Nr.11_1_021-1_v1"
      },
      {
        "id": "Nr.12_1_022-1_v1"
      },
      {
        "id": "Nr.13_1_023-1_v1"
      },
      {
        "id": "Nr.14_1_030-1_v1"
      },
      {
        "id": "Nr.15_1_031-1_v1"
      },
      {
        "id": "Nr.16_1_040-1_v1"
      },
      {
        "id": "Nr.17_1_041-1_v1"
      },
      {
        "id": "Nr.17_1_042-1_v1"
      },
      {
        "id": "Nr.19_1_043-1_v1"
      },
      {
        "id": "Nr.20_1_044-1_v1"
      },
      {
        "id": "Nr.1_1_001-1_v1"
      },
      {
        "id": "Nr.2_1_002-1_v1"
      },
      {
        "id": "Nr.3_1_003-1_v1"
      },
      {
        "id": "Nr.4_1_004-1_v1"
      },
      {
        "id": "Nr.5_1_005-1_v1"
      },
      {
        "id": "Nr.6_1_006-1_v1"
      },
      {
        "id": "Nr.7_1_007-1_v1"
      },
      {
        "id": "Nr.8_1_008-1_v1"
      },
      {
        "id": "Nr.9_1_009-1_v1"
      }
    ]
  },
  {
    "id": "Information zur Reisekette 2",
    "icons": [
      {
        "id": "Nr.10_4_061-1_v1"
      },
      {
        "id": "Nr.11_4_070-1_v1"
      },
      {
        "id": "Nr.1_4_001-1_v1"
      },
      {
        "id": "Nr.2_4_002-1_v1"
      },
      {
        "id": "Nr.3_4_010-1_v1"
      },
      {
        "id": "Nr.4_4_011-1_v1"
      },
      {
        "id": "Nr.5_4_012-1_v1"
      },
      {
        "id": "Nr.6_4_013-1_v1"
      },
      {
        "id": "Nr.7_4_014-1_v1"
      },
      {
        "id": "Nr.8_4_050-1_v1"
      },
      {
        "id": "Nr.9_4_060-1_v1"
      }
    ]
  },
  {
    "id": "Interne kommerzielle Einrichtungen",
    "icons": [
      {
        "id": "Nr.10_7_025-1_v1"
      },
      {
        "id": "Nr.11_7_030-1_v1"
      },
      {
        "id": "Nr.12_7_031-1_v1"
      },
      {
        "id": "Nr.1_7_001-1_v1"
      },
      {
        "id": "Nr.2_7_002-1_v1"
      },
      {
        "id": "Nr.3_7_003-1_v1"
      },
      {
        "id": "Nr.4_7_010-1_v1"
      },
      {
        "id": "Nr.5_7_020-1_v1"
      },
      {
        "id": "Nr.6_7_021-1_v1"
      },
      {
        "id": "Nr.7_7_022-1_v1"
      },
      {
        "id": "Nr.8_7_023-1_v1"
      },
      {
        "id": "Nr.9_7_024-1_v1"
      }
    ]
  },
  {
    "id": "Lageplan",
    "icons": [
      {
        "id": "Nr.1_9_001-1_v1"
      },
      {
        "id": "Nr.2_9_002-1_v1"
      },
      {
        "id": "Nr.3_9_003-1_v1"
      },
      {
        "id": "Nr.4_9_004-1_v1"
      }
    ]
  },
  {
    "id": "Serviceeinrichtungen",
    "icons": [
      {
        "id": "Nr.10_5_024-1_v1"
      },
      {
        "id": "Nr.11_5_025-1_v1"
      },
      {
        "id": "Nr.12_5_030-1_v1"
      },
      {
        "id": "Nr.13_5_031-1_v1"
      },
      {
        "id": "Nr.14_5_040-1_v1"
      },
      {
        "id": "Nr.15_5_050-1_v1"
      },
      {
        "id": "Nr.16_5_051-1_v1"
      },
      {
        "id": "Nr.17_5_052-1_v1"
      },
      {
        "id": "Nr.18_5_060-1_v1"
      },
      {
        "id": "Nr.19_5_061-1_v1"
      },
      {
        "id": "Nr.1_5_001-1_v1"
      },
      {
        "id": "Nr.20_5_062-1_v1"
      },
      {
        "id": "Nr.2_5_002-1_v1"
      },
      {
        "id": "Nr.3_5_010-1_v1"
      },
      {
        "id": "Nr.4_5_018-1_v1"
      },
      {
        "id": "Nr.5_5_019-1_v1"
      },
      {
        "id": "Nr.6_5_020-1_v1"
      },
      {
        "id": "Nr.7_5_021-1_v1"
      },
      {
        "id": "Nr.8_5_022-1_v1"
      },
      {
        "id": "Nr.9_5_023-1_v1"
      }
    ]
  },
  {
    "id": "Sicherheitseinrichtungen",
    "icons": [
      {
        "id": "Nr.1_2_001-1_v1"
      },
      {
        "id": "Nr.2_2_010-1_v1"
      },
      {
        "id": "Nr.3_2_020-1_v1"
      },
      {
        "id": "Nr.4_2_030-1_v1"
      },
      {
        "id": "Nr.5_2_040-1_v1"
      },
      {
        "id": "Nr.6_2_050-1_v1"
      },
      {
        "id": "Nr.7_2_060-1_v1"
      }
    ]
  },
  {
    "id": "01_Verkehrsmittel",
    "icons": [
      {
        "id": "Nr.10_3_061-1_v1"
      },
      {
        "id": "Nr.11_3_062-1_v1"
      },
      {
        "id": "Nr.12_3_070-1_v1"
      },
      {
        "id": "Nr.13_3_080-1_v1"
      },
      {
        "id": "Nr.14_3_090-1_v1"
      },
      {
        "id": "Nr.15_3_091-1_v1"
      },
      {
        "id": "Nr.16_3_092-1_v1"
      },
      {
        "id": "Nr.1_3_001-1_v1"
      },
      {
        "id": "Nr.2_3_002-1_v1"
      },
      {
        "id": "Nr.3_3_010-1_v1"
      },
      {
        "id": "Nr.4_3_020-1_v1"
      },
      {
        "id": "Nr.5_3_030-1_v1"
      },
      {
        "id": "Nr.6_3_040-1_v1"
      },
      {
        "id": "Nr.7_3_041-1_v1"
      },
      {
        "id": "Nr.8_3_050-1_v1"
      },
      {
        "id": "Nr.9_3_060-1_v1"
      }
    ]
  }
]
